import React from 'react'
import IconBase from 'react-icon-base'

export default props => (
  <IconBase viewBox="0 0 40 40" {...props}>
    <path
      d="M30.25,17.7l-6-0.4l0,0c-1.9,0-1.9-2.4-1.9-3.7c-0.1-0.2-1.1-0.5-2.1-0.5h-0.5c-1,0-1.9,0.3-2.1,0.5c0,1.3,0,3.7-2,3.7
      l-5.9,0.4l0,0c-1.1,0-2.1-0.7-2.3-1.7c-0.3-1.4-0.5-4.1,1.3-6.3c1.9-2.4,5.6-3.6,10.9-3.6h0.7c5.3,0,8.9,1.2,10.9,3.6
      c1.801,2.3,1.6,4.9,1.301,6.3C32.35,17,31.35,17.7,30.25,17.7z M24.449,15.3l5.9,0.4c0.1,0,0.201-0.1,0.301-0.1
      c0.199-1,0.4-3-0.9-4.6c-1.5-1.9-4.699-2.9-9.3-2.9h-0.8c-4.6,0-7.8,1-9.3,2.9c-1.3,1.6-1.1,3.6-0.9,4.6l0,0c0,0,0.1,0.1,0.3,0.1
      l5.8-0.4c0.1-0.2,0.1-0.7,0.1-1.7c0-0.6,0.2-1.1,0.6-1.5c0.8-0.8,2.3-1,3.2-1h0.1c0.1,0,0.2,0,0.4,0c0.2,0,0.3,0,0.4,0h0.1
      c1,0,2.4,0.3,3.201,1c0.4,0.4,0.6,0.9,0.6,1.5C24.25,14.6,24.35,15.1,24.449,15.3z M24.25,15.3L24.25,15.3L24.25,15.3z"
    />
    <rect x="12.688" y="20" width="2" height="13.625" />
    <rect x="19" y="20" width="2" height="13.625" />
    <rect x="25.313" y="20" width="2" height="13.625" />
  </IconBase>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Icons/PhoneLines.jsx